// Typelizer digest 77a58e89220bd4f9d9909384d5f39cdc
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/teams/:team_id/members */
  index: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/members', params, options),
    method: 'get',
  }),

  /** POST /educators/teachers/:teacher_id/teams/:team_id/members */
  create: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/members', params, options),
    method: 'post',
  }),

  /** GET /educators/teachers/:teacher_id/teams/:team_id/members/new */
  new: (
    params: { teacherId: string | number; teamId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/members/new', params, options),
    method: 'get',
  }),

  /** DELETE /educators/teachers/:teacher_id/teams/:team_id/members/:id */
  destroy: (
    params: { teacherId: string | number; teamId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/teams/:team_id/members/:id', params, options),
    method: 'delete',
  }),
}
